import * as React from 'react';

import { Flex, Text } from '@ttoss/ui';
import { useNavigation } from '../../providers/NavigationProvider/NavigationProvider';

import Button from '../Button/Button';

const TIMEOUT_TO_APPEAR = 5000;

const PopUpSpecialist = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { onClosePopUpSpecialist } = useNavigation();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setIsOpen(true);
    }, TIMEOUT_TO_APPEAR);

    return () => clearTimeout(timeout);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Flex
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Flex
        sx={{
          width: 256,
          backgroundColor: 'white',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxShadow: 1,
          paddingX: 7,
          paddingY: 9,
        }}
      >
        <Text
          sx={{
            fontWeight: 700,
          }}
        >
          Lembrete:
        </Text>
        <Text sx={{ textAlign: 'center', marginY: 7 }}>
          Sempre consulte um responsável técnico
        </Text>
        <Button
          sx={{ backgroundColor: 'primary' }}
          onClick={() => {
            setIsOpen(false);
            onClosePopUpSpecialist();
          }}
        >
          Ok
        </Button>
      </Flex>
    </Flex>
  );
};

export default PopUpSpecialist;
